import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PasswordInput from '../../../PasswordInput';
import { validateFullName } from '../../../../formValidators';
import StyledTextField from '../../../common/StyledTextField';

class LazyFinish extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fullName: '',
      password: '',
      submitted: false,
      errors: {},
    };

    this.handleUpdateField = this.handleUpdateField.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleValidate() {
    const {
      fullName, password, termsCheckbox, errors,
    } = this.state;

    const fullNameValidation = validateFullName(fullName);
    this.setState({
      errors: {
        ...errors,
        fullName: fullNameValidation.error,
        password: password.length ? null : 'Please fill out this field.',
        termsCheckbox: termsCheckbox ? null : 'Please check this box if you want to proceed.',
      },
    });
    return fullNameValidation.isValid && password.length && termsCheckbox;
  }

  handleUpdateField(field) {
    return (e) => (
      this.setState({ [field]: field === 'termsCheckbox' ? e.target.checked : e.target.value })
    );
  }

  handleSubmit(e) {
    if (this.handleValidate()) {
      this.setState({ submitted: true });
    } else {
      e.preventDefault();
    }
  }

  render() {
    const { csrfToken, onboardType } = this.props;
    const {
      fullName, submitted, errors, termsCheckbox,
    } = this.state;

    return (
      <div className="finish-container style-guide">
        <div className="lazy-finish">
          <h1>Set your password to start your application!</h1>
          <div className="lazy-finish-child">
            <form
              id="create_consultant"
              className="edit_user"
              action="/users/finish-onboarding"
              acceptCharset="UTF-8"
              method="post"
              onSubmit={this.handleSubmit}
            >
              <input type="hidden" name="authenticity_token" value={csrfToken} />
              <StyledTextField
                id="full_name"
                className="form-control fs-hide"
                value={fullName}
                error={!!errors.fullName}
                helperText={errors.fullName}
                onChange={this.handleUpdateField('fullName')}
                name="user[full_name]"
                label="Full Name"
                type="text"
              />
              <PasswordInput
                errors={errors.password}
                title="Password"
                handleChange={this.handleUpdateField('password')}
              />
              <div className="form-group">
                <input
                  className="form-control terms-and-privacy-checkbox"
                  type="checkbox"
                  name="user[terms_and_privacy_consent]"
                  id="terms-and-privacy-checkbox"
                  tabIndex="0"
                  value={termsCheckbox}
                  onChange={this.handleUpdateField('termsCheckbox')}
                />
                <label
                  htmlFor="consultant-terms-and-privacy-consent"
                  className="ms-2 terms-and-privacy-checkbox body-text-2 regular"
                >
                  I agree to Clora's
                  <a href="/terms-of-use"> Terms of Use</a>
                  {' '}
                  and
                  <a href="/privacy-policy"> Privacy Policy</a>
                  .
                </label>
                { errors.termsCheckbox
                  ? (
                    <p className="error-text">
                      { errors.termsCheckbox }
                    </p>
                  ) : ''}
              </div>
              <div className="actions mt-4">
                <button
                  type="submit"
                  name="commit"
                  id={`${onboardType}-consultant-sign-up`}
                  className="btn btn-primary full-width"
                  disabled={submitted}
                  tabIndex="0"
                >
                  Set Password
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

LazyFinish.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  onboardType: PropTypes.string.isRequired,
};

export default LazyFinish;
